<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/XPgkK4/tc-custom/9781611216561.jpg?1713957267249" alt="This image is the cover for the book Battle of Jackson, Mississippi"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Battle of Jackson, Mississippi
      </h1>
      <p class="bookDescription body article font2">
        <b>“A comprehensive, eminently readable, lavishly illustrated, and historically accurate account” of this important yet overlooked Civil War battle (<i>Civil War News</i>).</b><br/><br/>Jackson, Mississippi, was the third Confederate state capital to fall to Union forces. When Maj. Gen. Ulysses S. Grant captured the important rail junction in May 1863, however, he did so almost as an afterthought. Drawing on dozens of primary sources, contextualized by the latest scholarship on Grant’s Vicksburg campaign, historian Chris Mackowski offers a comprehensive account of this important battle.<br/><br/>General Grant had his eyes set not on Jackson but on Vicksburg, the “Gibraltar of the Confederacy”. As he drove through Mississippi, a chance encounter with Confederates at Raymond alerted him to a potential threat massing farther east in Jackson under the leadership of Gen. Joseph E. Johnston, one of the Confederacy’s most respected field officers. Grant turned on a dime and made for Jackson to confront the growing danger. Yet Johnston, for reasons that have long puzzled historians, was already planning to abandon the vital state capital.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Chris Mackowski
      </h2>
      
      <p class="authorDescription body article">Chris Mackowski, Ph.D., is the editor-in-chief and co-founder of Emerging Civil War and the series editor of the award-winning Emerging Civil War Series published by Savas Beatie. Chris is a writing professor in the Jandoli School of Communication at St. Bonaventure University in Allegany, NY, where he also serves as associate dean for undergraduate programs. Chris is also historian-in-residence at Stevenson Ridge, a historic property on the Spotsylvania battlefield in central Virginia.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Savas Beatie
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?98051180